module.exports = __webpack_public_path__ + "img/denmark-colorectal-cancer-female.55d9b918.png";